module.exports = __webpack_public_path__ + "static/img/fanyi.6b88e299.png";